import { useEffect } from 'react';
import { shallowEqual } from 'react-redux';

import { useConfiguration } from '../../../../components/ApplicationProviders/ConfigurationProvider/ConfigurationProvider';
import { useAppDispatch, useAppSelector } from '../../../../stores/redux-store';
import { fetchDuplicatePayment } from '../../services/payments-services';
import { applicationParameters } from '../../../../utilities/application-parameters';

export const useDoublePaymentCheck = () => {
  const dispatch = useAppDispatch();
  const { duplicatePaymentState, doublePaymentCheckLoading: loading } = useAppSelector(
    (state) => state.paymentDetails,
    shallowEqual
  );
  const { data: config } = useConfiguration();
  const paymentRequestId = applicationParameters.get('paymentRequestId') as string;

  useEffect(() => {
    dispatch(fetchDuplicatePayment(paymentRequestId, config));
  }, [dispatch, paymentRequestId, config]);

  return { loading, duplicatePaymentState };
};
